export default __webpack_public_path__ + "static/media/Naurynskyi.6a70025c.png";